<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'notifications-layout-page',
}
</script>
